// Convert typeNavn to category key used in the program data
export const toCategoryKey = typeNavn => {
    const t = (typeNavn || '').toString().trim().toUpperCase();
    if (t === 'FELLES') return 'fellesprogram';
    return t.toLowerCase();
};
